import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DignityThroughBasicNeeds from "./sections/DignityThroughBasicNeeds";
import SignatureProjects from "./sections/SignatureProjects";
import PaintingServices from "./sections/PaintingServices";
import ImpactByTheNumbers from "./sections/ImpactByTheNumbers";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DignityThroughBasicNeeds />
      <SignatureProjects />
      <PaintingServices />
      <ImpactByTheNumbers />
      <Footer />
    </div>;
}